module.exports = __webpack_public_path__ + "img/377.adaa70a9.jpg";